import { render, staticRenderFns } from "./EditCellEmail.vue?vue&type=template&id=afe4bc26&scoped=true&"
import script from "./EditCellEmail.vue?vue&type=script&lang=js&"
export * from "./EditCellEmail.vue?vue&type=script&lang=js&"
import style0 from "./EditCellEmail.vue?vue&type=style&index=0&id=afe4bc26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe4bc26",
  null
  
)

export default component.exports